import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fillMissingDates } from 'utils/roster';
import { fetchRosterByUserId } from 'services/attendance';
import { ATTENDANCE_QUERY_KEYS } from './keys';
import type { QueryObject } from 'interface/queryParam';
import type { RosterItem } from 'interface/roster';

type RosterParams = QueryObject & {
  userIds?: string | number | Array<string | number>;
  startDate?: string;
  endDate?: string;
};

export function useFetchRosterData(params: RosterParams = {}): UseQueryResult<RosterItem[], Error> {
  return useQuery<RosterItem[], Error>({
    queryKey: [ATTENDANCE_QUERY_KEYS.ROSTER, params],
    queryFn: () => fetchRosterByUserId(params) as Promise<RosterItem[]>,
    enabled: Boolean(params.userIds) && Boolean(params.startDate) && Boolean(params.endDate),
    select: (data: RosterItem[]) => {
      return params.startDate && params.endDate ? fillMissingDates(data, params.startDate, params.endDate) : data;
    },
  });
}
